import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { createSocketToken, refreshSocketToken } from "./thunkAction";
import * as Moment from "moment";

const TOKEN_EXPIRE = 7 * 24 * 60 * 60 * 1000; //7d

const initialState = {
  hasToken: false,
  socketToken: null,
  error: null,
};

const tokenSlice = createSlice({
  name: "tokenManage",
  initialState,
  reducers: {
    checkToken(state) {
      const accessToken = sessionStorage.getItem("accessToken") || "";
      state.hasToken = !!accessToken;
    },
    getSocketToken(state, action) {
      const domain = _.get(action, "payload", null);
      const raw = localStorage.getItem(`${domain}_socket_token`);

      try {
        const data = JSON.parse(raw);
        // const expiresAt = _.get(data, "expiresAt");
        const socketToken = _.get(data, "socketToken", null);
        // const isExpired = +Moment.utc() > expiresAt;

        // if (isExpired) {
        //   localStorage.removeItem(`${domain}_socket_token`);
        //   state.socketToken = null;

        //   return;
        // }

        state.socketToken = socketToken;
      } catch {
        localStorage.removeItem(`${domain}_socket_token`);
        state.socketToken = null;
      }
    },
    clearSocketToken(state, action) {
      const domain = _.get(action, "payload", null);
      state.socketToken = null;
      if (domain) {
        localStorage.removeItem(`${domain}_socket_token`);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // createSocketToken
      .addCase(createSocketToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSocketToken.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const result = _.get(action, "payload", "");
        try {
          const payload = JSON.parse(result);

          const socketToken = _.get(payload, "token");
          const domain = _.get(payload, "domain");
          state.socketToken = socketToken;
          const data = {
            socketToken,
            // expiresAt: +Moment.utc() + TOKEN_EXPIRE,
          };
          localStorage.setItem(`${domain}_socket_token`, JSON.stringify(data));
        } catch {
          state.socketToken = null;
        }
      })
      .addCase(createSocketToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // refreshSocketToken
      .addCase(refreshSocketToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(refreshSocketToken.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const result = _.get(action, "payload", "");
        try {
          const payload = JSON.parse(result);

          const socketToken = _.get(payload, "token");
          const domain = _.get(payload, "domain");
          const data = {
            socketToken,
            // expiresAt: +Moment.utc() + TOKEN_EXPIRE,
          };
          localStorage.setItem(`${domain}_socket_token`, JSON.stringify(data));
        } catch {}
      })
      .addCase(refreshSocketToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const tokenReducer = tokenSlice.reducer;

export const tokenAction = tokenSlice.actions;
